const init = () => {
    const purchaseForm = document.getElementById("purchase-form");
    if (purchaseForm) {
        const radioFieldset = document.querySelector("fieldset.radio_numberOfSensor");
        const firstChoice = radioFieldset?.querySelector(".gchoice");
        const buttonGroup = document.querySelector("fieldset.button_group");

        if (firstChoice && buttonGroup) {
            firstChoice.insertAdjacentElement("afterend", buttonGroup);
        }
    }
}

export default init;